import React, { useContext } from 'react';
import { ChevronDown, Search } from 'lucide-react';
import WebsocketWrapperContext from '../../../context/WebsocketWrapperContext';
import upArrowSvg from "../../../images/Builder/global_market_pos.svg";
import downArrowSvg from "../../../images/Builder/global_market_neg.svg";
import { useNavigate } from 'react-router-dom';

export function TabContent({ symbol, fromSearchTab = false, onOpenSearch }) {
    const { symbolData } = useContext(WebsocketWrapperContext);
    const data = symbolData[symbol?.code];
    const navigate = useNavigate();

    const renderTrendArrow = (change) => {
        if (change === undefined) return null;
        return (
            <img
                src={change > 0 ? upArrowSvg : downArrowSvg}
                alt={change > 0 ? "Up" : "Down"}
                className={`trend-arrow ${change > 0 ? 'up' : 'down'}`}
                width="16"
                height="16"
            />
        );
    };

    if (!data) {
        return (
            <div className="bg-p400 shadow-sm rounded-b-md p-4 py-[18px] flex items-center justify-between">
                <div className="flex items-center space-x-3 animate-pulse w-full">
                    <div className="w-11 h-10 bg-n200 rounded-full"></div>
                    <div className="flex-1 space-y-2">
                        <div className="h-4 bg-n200 rounded w-32"></div>
                        <div className="h-4 bg-n200 rounded w-20"></div>
                    </div>
                </div>
            </div>
        );
    }

    const symbolChange = data?.change;
    const symbolChangePer = data?.change_per;

    return (
        <div className='bg-p400 shadow-sm rounded-b-md p-4 py-3 flex items-center justify-between'>
            <div className='flex justify-between items-center w-full'>
                <div className="flex items-center space-x-3">
                    <div className="w-11 h-10 bg-n100 rounded-full flex items-center justify-center text-n700 text-xl font-semibold">
                        {symbol?.scrip[0]}
                    </div>
                    <div className='items-center'>
                        <div className="flex items-center font-medium text-p300">
                            <span>{symbol?.scrip}</span>
                            <span className='ml-2'>{renderTrendArrow(symbolChange)}</span>
                        </div>
                        <div className='flex items-center gap-3'>
                            <div className="text-lg font-bold text-p300">
                                {data?.ltp.toLocaleString('en-IN')}
                            </div>
                            <div className="text-sm">
                                <span className={`font-medium ${symbolChange > 0 ? 'text-p150' : 'text-red'}`}>
                                    {symbolChange > 0 ? "▲" : "▼"}
                                    {symbolChange > 0 ? "+" : ""}
                                    {String(symbolChange).split(".")[0]}.
                                    <span>{String(symbolChange).split(".")[1]}</span> (
                                    {String(symbolChangePer).split(".")[0]}.
                                    <span>{String(symbolChangePer).split(".")[1]}</span>%)
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                    <div className='ml-auto flex items-center gap-4'>
                        {symbol.exchange === 'NSE' && (
                        <div
                            className="cursor-pointer"
                            onClick={() => {
                                console.log(symbol?.scrip, 'scrip');
                                navigate(`/scanners?scrip=${symbol.scrip}&exchange=${symbol.exchange}&code=${symbol.code}`);

                            }}
                        >
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.66797 7.49984V5.83317C1.66797 3.33317 3.33464 1.6665 5.83464 1.6665H14.168C16.668 1.6665 18.3346 3.33317 18.3346 5.83317V7.49984" fill="#CFCFCF" />
                                <path d="M1.66797 7.49984V5.83317C1.66797 3.33317 3.33464 1.6665 5.83464 1.6665H14.168C16.668 1.6665 18.3346 3.33317 18.3346 5.83317V7.49984" stroke="#0F0F0F" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M1.66797 12.5V14.1667C1.66797 16.6667 3.33464 18.3333 5.83464 18.3333H14.168C16.668 18.3333 18.3346 16.6667 18.3346 14.1667V12.5" fill="#CFCFCF" />
                                <path d="M1.66797 12.5V14.1667C1.66797 16.6667 3.33464 18.3333 5.83464 18.3333H14.168C16.668 18.3333 18.3346 16.6667 18.3346 14.1667V12.5" stroke="#0F0F0F" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M1.66797 10H18.3346" stroke="#0F0F0F" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                        </div>
                        )}
                        {fromSearchTab && (
                            <div className=" cursor-pointer" onClick={onOpenSearch}>
                                <Search className="w-6 h-6 text-gray-500" />
                            </div>
                        )}
                    </div>
                
            </div>
        </div>
    );
}
